import kr from '../kr/kr';

export default class ToggleFormVisibility extends kr.Component {
    init() {
        this.init();
    }
    init() {
        const closeMainLayerButton =  document.querySelector('.reviews__close-button');
        const openMainLayerButton =  document.querySelector('.reviews__add-review');

        closeMainLayerButton.addEventListener('click', ()=> {
            this.$element.style.display = 'none';
        })
        openMainLayerButton.addEventListener('click', ()=> {
            this.$element.style.display = 'block';
        })
    }
}

kr.registerComponent('.reviews__add-popup', {
    component: ToggleFormVisibility
});